module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "to": "/#donate"
    }
  }, [_vm._v("Donate Now")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/DSC_0361.jpeg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f1fd262!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurStory/PencilsChangeLives.vue
// module id = 313
// module chunks = 1